module.exports = __webpack_public_path__ + "img/电子科技大学.30a7016f.png";